'use client'

import { MoreVertIcon } from '@repo/ui/MoreVertIcon'
import { PopupWithBackdrop } from '@repo/ui/PopupWithBackdrop'
import { useKeyDateStore } from '@repo/store/useKeyDateStore'
import { useMattersStore } from '@repo/store/useMattersStore'
import { useMenuItemsStore } from '@repo/store/useMenuItemsStore'
import { useMenuState, MenuItem } from '@szhsin/react-menu'
import { useRef } from 'react'
import { useUrlStore } from '@repo/store/useUrlStore'
import MUIIconButton from '@mui/material/IconButton'
import MUIStack from '@mui/material/Stack'
import MUITypography from '@mui/material/Typography'
import PropTypes from 'prop-types'

export const ComingUpOverflowMenu = ({ item }) => {
  const { navigateWithClientMatterNo } = useUrlStore()
  const [menuState, toggleMenu] = useMenuState({ transition: true })
  const { toggleKeyDatesDrawer, getKeyDate, updateKeyDate } = useKeyDateStore()
  const { setMatterDrawerIsOpen } = useMattersStore()
  const ref = useRef(null)
  const { allowedActions } = useMenuItemsStore()
  const allowEditMatters = allowedActions?.editMatters?.allowed || false
  const allowViewKeyDates = allowedActions?.viewKeyDates?.allowed || false
  const allowEditKeyDates = allowedActions?.editKeyDates?.allowed || false

  const handleViewKeyDate = (e, mode) => {
    e.preventDefault()
    e.stopPropagation()
    toggleKeyDatesDrawer({
      keyDatesDrawerIsOpen: true,
      keyDatesDrawerItemId: item.keyDateId,
      keyDatesDrawerMode: mode
    })
    toggleMenu(false)
  }

  const markKeyDateMet = async (e) => {
    e.preventDefault()
    e.stopPropagation()

    const keyDate = await getKeyDate({ id: item.keyDateId })
    const successToastMessage = `Key date marked as met\n${keyDate.clientNo}-${keyDate.matterNo}${keyDate.notes ? `: ${keyDate.notes}` : ''}`
    await updateKeyDate({ ...keyDate, dateMet: true }, successToastMessage)
  }

  const handleViewMatterReview = (e, mode) => {
    e.preventDefault()
    e.stopPropagation()

    if (mode === 'view') {
      setMatterDrawerIsOpen(true, item.clientNo, `${item.clientNo}-${item.matterNo}`)
    } else {
      navigateWithClientMatterNo({
        route: `/case-management/matters/matter-detail/edit-matter`,
        clientMatterNo: `${item.clientNo}-${item.matterNo}`,
        appendClientMatterNo: true
      })
    }

    toggleMenu(false)
  }

  const handleOverflowMenuClick = (e, bool) => {
    e.preventDefault()
    e.stopPropagation()
    toggleMenu(bool)
  }

  return (
    <MUIStack data-testid="ComingUpOverflowMenu">
      <MUIIconButton onClick={(e) => handleOverflowMenuClick(e, true)} ref={ref} disabled={item?.isUserRestricted}>
        <MoreVertIcon sx={{ height: '20px', width: '20px', opacity: item?.isUserRestricted ? 0.5 : 1 }} />
      </MUIIconButton>

      {item?.upcomingDateType === 'KeyDate' && (allowViewKeyDates || allowEditKeyDates) ? (
        <PopupWithBackdrop
          menuState={menuState}
          anchorRef={ref}
          toggleMenu={toggleMenu}
          className="comingUpItemMoreMenu"
        >
          {allowViewKeyDates ? (
            <MenuItem>
              <MUITypography sx={{ mb: 0, cursor: 'pointer' }} onClick={(e) => handleViewKeyDate(e, 'view')}>
                View key date
              </MUITypography>
            </MenuItem>
          ) : null}

          {allowEditKeyDates ? (
            <MenuItem>
              <MUITypography sx={{ mb: 0, cursor: 'pointer' }} onClick={markKeyDateMet}>
                Mark key date as met
              </MUITypography>
            </MenuItem>
          ) : null}

          {allowEditKeyDates ? (
            <MenuItem>
              <MUITypography sx={{ mb: 0, cursor: 'pointer' }} onClick={(e) => handleViewKeyDate(e, 'edit')}>
                Edit key date
              </MUITypography>
            </MenuItem>
          ) : null}
        </PopupWithBackdrop>
      ) : (
        <PopupWithBackdrop
          menuState={menuState}
          anchorRef={ref}
          toggleMenu={toggleMenu}
          className="comingUpItemMoreMenu"
        >
          <MenuItem>
            <MUITypography sx={{ mb: 0, cursor: 'pointer' }} onClick={(e) => handleViewMatterReview(e, 'view')}>
              View matter
            </MUITypography>
          </MenuItem>

          {allowEditMatters ? (
            <MenuItem>
              <MUITypography sx={{ mb: 0, cursor: 'pointer' }} onClick={(e) => handleViewMatterReview(e, 'edit')}>
                Edit matter
              </MUITypography>
            </MenuItem>
          ) : null}
        </PopupWithBackdrop>
      )}
    </MUIStack>
  )
}

ComingUpOverflowMenu.propTypes = {
  item: PropTypes.object
}
